import { getPrice } from '@sigma-frontend-libs/commons'

import { proxy, services } from '@/utils'

import render from './render'

export default {
  name: 'NotificationsEventsBillingsLimitPanel',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    index: {
      type: Number,
      default: undefined
    },

    path: {
      type: String,
      default: undefined
    },
    currency: {
      type: String,
      default: undefined
    },

    overdraft: {
      type: Number,
      default: 0
    },

    permission: {
      type: [ String, Boolean ],
      default: undefined
    }
  },

  methods: {
    getLabel(balance, includeOverdraft) {
      let amount = balance
      if (includeOverdraft) {
        amount = getPrice(balance - this.overdraft, { currency: this.currency })
      } else {
        amount = getPrice(balance, { currency: this.currency })
      }
      const targetAmount = parseFloat(amount)
      let result = this.getTranslate(`${services.settingsUser}.hints.${this.path}.balance`, { amount })
      if (!isNaN(targetAmount) && targetAmount == 0) {
        result = this.getTranslate(`${services.settingsUser}.hints.${this.path}.onNullBalance`)
      }

      return result
    }
  },

  render
}
